import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useFinance } from "../FinanceContext";

/** Small panel on the Dashboard listing recent non-login audit events. */
export function RecentChanges() {
  const { audit, setPage } = useFinance();
  const items = audit
    .filter((a) => a.action !== "Login" && a.action !== "Role switched")
    .slice(0, 6);
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        Recent Changes
      </Typography>
      <List dense disablePadding>
        {items.map((a) => (
          <ListItemButton key={a.id} onClick={() => setPage("audit")} sx={{ px: 0 }}>
            <ListItemText
              primary={a.action}
              secondary={a.detail.length > 60 ? a.detail.slice(0, 60) + "…" : a.detail}
            />
          </ListItemButton>
        ))}
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No recent changes yet.
          </Typography>
        ) : null}
      </List>
    </Paper>
  );
}
